export const environment = {
  production: false,
  oktaRedirectUrl: (window as any).envConfig?.oktaRedirectUrl || 'default',
  oktaAuthority: (window as any).envConfig?.oktaAuthority || 'default',
  ddApplicationId: (window as any).envConfig?.ddApplicationId || 'default',
  ddClientToken: (window as any).envConfig?.ddClientToken || 'default',
  api: {
    env: (window as any).envConfig?.env || 'default',
    baseUrl: (window as any).envConfig?.baseUrl || 'default',
    clientId: (window as any).envConfig?.clientId || 'default',
    commodities: 'commodities',
    productClasses: 'productClasses',
    productClassConfigs: 'productClassConfigs',
    commodityProductClasses: 'commodityProductClasses',
    driverConfig: 'driverConfigs',
    driverSchedules: 'driverSchedules',
    driverScheduleViews: 'driverScheduleViews',
    shiftViews: 'shiftViews',
    shifts: 'shifts',
    drivers: 'drivers',
    nonActivity: 'nonActivities',
    nonActivityConfig: 'nonActivityConfigs',
    calculationLineItems: 'calculationLineItems',
    calculationLineItemViews: 'calculationLineItemViews',
    calculationTrips: 'calculationTrips',
    calculationDriverWeeks: 'calculationDriverWeeks',
    calculationAccidents: 'calculationAccidents',
    payDateViews: 'payDateViews',
    workWeeks: 'workWeeks',
    tripOverrides: 'tripOverrides',
    facilityConfig: 'facilityConfigs',
    facilities: 'facilities',
    driverPayWeeksUrl: 'payWeeks',
    activities: 'activities',
    activityConfigs: 'activityConfigs',
    activityOverrides: 'activityOverrides',
    qualifyingFacilities: 'activityQualifyingFacilities',
    qualifyingFacilityTypes: 'activityQualifyingFacilityTypes',
    qualifyingMoveTypes: 'activityQualifyingMoveTypes',
    qualifyingStopActions: 'activityQualifyingStopActions',
    qualifyingDates: 'activityQualifyingDates',
    qualifyingDays: 'activityQualifyingDayOfWeeks',
    qualifyingConflicts: 'activityQualifyingConflicts',
    qualifyingProductClasses: 'activityQualifyingProductClasses',
    calculationWageSheetPreviews: 'calculationWageSheetPreviews',
    warehouseTerminals: 'warehouseTerminals',
    trips: 'trips',
    segments: 'segments',
    stops: 'stops',
    stopProductClasses: 'stopProductClasses',
    additionalActions: 'additionalActions',
    actions: 'actions',
    zones: 'zones',
    facilityZones: 'facilityZones',
    driverNonActivities: 'driverNonActivities',
    disasters: 'disasters',
    mitigations: 'disasterMitigations',
    mitigationDrivers: 'disasterMitigationDrivers',
    mitigationFacilities: 'disasterMitigationFacilities',
    rateFlats: 'rateFlats',
    users: 'users',
  },
};
